import React, { useState } from "react";
import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { TiltCard } from "./TiltCard";
import { CARDS } from "@/data";

const OracleCard = ({ card, index }) => {
  const [flipped, setFlipped] = useState(false);

  return (
    <TiltCard
      className="shrink-0 w-[240px] md:w-[270px] cursor-pointer"
      max={12}
      glare={false}
      onClick={() => setFlipped((f) => !f)}
    >
      <div
        data-testid="card-gallery-item"
        className="relative w-full aspect-[9/16] rounded-lg"
        style={{
          transformStyle: "preserve-3d",
          transition: "transform 0.6s",
          transform: flipped ? "rotateY(180deg)" : "rotateY(0deg)",
        }}
      >
        {/* FRONT — real card art */}
        <div
          className="absolute inset-0 rounded-lg overflow-hidden border border-sf-border bg-black"
          style={{ backfaceVisibility: "hidden" }}
        >
          <img
            src={card.img}
            alt={`${card.name} — ${card.keywords.join(", ")} oracle card`}
            loading="lazy"
            className="w-full h-full object-cover"
          />
          <div className="absolute top-3 left-3 font-mono text-[10px] tracking-[0.2em] text-sf-bone/70 bg-black/50 px-2 py-0.5 rounded-sm">
            {String(index + 1).padStart(2, "0")}/49
          </div>
          <div className="absolute bottom-3 right-3 font-mono text-[9px] uppercase tracking-[0.2em] text-sf-bone/60 bg-black/50 px-2 py-0.5 rounded-sm">
            Tap to read
          </div>
        </div>

        {/* BACK — keywords */}
        <div
          className="absolute inset-0 rounded-lg border border-sf-ember/40 bg-sf-surface p-7 flex flex-col justify-center"
          style={{ backfaceVisibility: "hidden", transform: "rotateY(180deg)" }}
        >
          <div className="absolute inset-0 sf-scanlines opacity-20 rounded-lg" />
          <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-sf-ember">Card {String(index + 1).padStart(2, "0")}</div>
          <h3 className="mt-3 sf-stencil text-3xl tracking-wide text-sf-bone leading-none">{card.name}</h3>
          <div className="h-0.5 w-12 my-5 bg-gradient-to-r from-sf-emberDeep to-sf-emberBright" />
          <ul className="space-y-2.5">
            {card.keywords.map((k) => (
              <li key={k} className="font-mono text-sm uppercase tracking-[0.15em] text-sf-dim">
                <span className="text-sf-ember">·</span> {k}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </TiltCard>
  );
};

export const CardGallery = () => {
  return (
    <section id="cards" data-testid="card-gallery-section" className="relative py-24 md:py-32 bg-sf-surface/30 overflow-hidden">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-8 bg-sf-ember" />
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-sf-ember">Recon · The Cards</span>
          </div>
          <div className="flex flex-wrap items-end justify-between gap-4">
            <h2 className="sf-stencil text-4xl md:text-5xl text-sf-bone max-w-2xl leading-[1.05]">
              Five of forty-nine.
            </h2>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-sf-muted">Tap a card to flip · hover to tilt</p>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.1}>
        <div className="mt-14 flex gap-6 overflow-x-auto sf-no-scrollbar px-6 md:px-12 pb-6 max-w-7xl mx-auto">
          {CARDS.map((c, i) => (
            <motion.div key={c.name} whileHover={{ y: -6 }}>
              <OracleCard card={c} index={i} />
            </motion.div>
          ))}
        </div>
      </Reveal>
    </section>
  );
};

export default CardGallery;
